export default __webpack_public_path__ + "static/media/exclusive-the-strip-district.8847eccc.png";